<template>
    <div class="d-flex flex-column">
        <v-col cols="12" class="mt-6" v-if="colIsReady">
            <v-row
                v-for="(tooltipData, index) in tooltipsList"
                :key="index"
                class="row_tooltipdata"
            >
                <v-col
                    sm="3"
                    class="text-center text-md-right d-flex align-items-center"
                >
                    <v-select
                        v-if="tooltipData.isEditable"
                        v-model="tooltipData.moduleId"
                        :items="
                            availableModules.map((el) => ({
                                text: el.name,
                                value: el.value,
                            }))
                        "
                        hide-details
                        :readonly="!tooltipData.isEditable"
                        :rules="formRules.defaultRules"
                        :menu-props="{ top: false, offsetY: true }"
                    />
                    <span v-else>
                        {{ renderModuleName(tooltipData.moduleId) }}
                    </span>
                </v-col>
                <v-col
                    sm="2"
                    class="text-center text-md-right d-flex align-items-center"
                >
                    <div>
                        <label :for="`upload-photo_${index}`">
                            <a class="button-upload">
                                <img
                                    src="/images/_SVGs/environmental/upload.svg"
                                    class="mr-3"
                                    alt="image"
                                    width="20"
                                    height="20"
                                />{{
                                    $t(
                                        "environmental-management.documentation.charge-file"
                                    )
                                }}
                            </a>
                        </label>
                        <input
                            type="file"
                            name="file"
                            class="upload-photo"
                            :key="tooltipData.moduleId"
                            :id="`upload-photo_${index}`"
                            v-on:change="previewImage($event, tooltipData)"
                            accept=".jpg, .png"
                        />
                    </div>
                </v-col>
                <v-col sm="1" class="ml-4 d-flex align-items-center">
                    <div v-if="tooltipData.image">
                        <img
                            v-if="tooltipData.isEditable"
                            :src="tooltipData.image"
                            style="width: 40px"
                        />
                        <img
                            v-else
                            :src="
                                tooltipData.image + '?version' + Math.random()
                            "
                            style="width: 40px"
                        />
                    </div>
                </v-col>
                <v-col sm="1" v-if="!tooltipData.isEditable">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="handleDeleteTooltipModule(tooltipData)"
                                :key="tooltipData.moduleId"
                                :id="`span-delete_${index}`"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <img
                                    src="/images/_SVGs/bo/remove.svg"
                                    style="cursor: pointer"
                                    width="25"
                                    height="25"
                                />
                            </span>
                        </template>
                        <span>{{
                            $t("backoffice.notifications.modules.remove-row")
                        }}</span>
                    </v-tooltip>
                </v-col>
                <v-col sm="1" v-else>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                v-bind="attrs"
                                v-on="on"
                                :style="
                                    tooltipData.moduleId !== '' &&
                                    tooltipData.image !== ''
                                        ? 'cursor: pointer; widht:20px; margin-right: 5px;'
                                        : 'cursor: no-drop; widht:20px; margin-right: 5px;'
                                "
                                @click="handleClickToSave(tooltipData)"
                            >
                                <img
                                    src="/images/_SVGs/bo/check.svg"
                                    onload="SVGInject(this)"
                                    width="15"
                                    height="15"
                                    fill="green"
                                />
                            </span>
                        </template>
                        <span>{{ $t("backoffice.actions.record") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                v-bind="attrs"
                                v-on="on"
                                style="cursor: pointer; widht: 20px"
                                @click="handleClickClose(tooltipData)"
                            >
                                <img
                                    src="/images/_SVGs/environmental/fechar.svg"
                                    onload="SVGInject(this)"
                                    width="25"
                                    height="25"
                                    fill="red"
                                />
                            </span>
                        </template>
                        <span>{{ $t("backoffice.actions.cancel") }}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" class="mt-4">
            <v-btn
                fab
                ref="ref_btn_plus_dtl"
                dark
                x-small
                :color="addModeActivated ? '#eeeeee' : '#F59534'"
                rounded
                class="add-btn"
                style="min-width: 30px !important"
                :style="addModeActivated ? 'cursor: no-drop' : ''"
                @click="addNewModuleTooltip"
                :readonly="addModeActivated"
            >
                <v-icon
                    :style="addModeActivated ? 'color: grey' : 'color: white'"
                >
                    mdi-plus
                </v-icon>
            </v-btn>
            <span
                class="ml-4"
                style="cursor: pointer"
                @click="addNewModuleTooltip"
                :style="addModeActivated ? 'cursor: no-drop' : ''"
            >
                {{ $t("backoffice.notifications.modules.add-module") }}
            </span>
        </v-col>

        <base-modal
            v-model="modalRequest.show"
            modalAlign="align__flex--center"
            :title="modalRequest.title"
            modal-width="460px"
            :iconColor="modalRequest.iconColor"
            :iconName="modalRequest.iconName"
        >
            <template v-slot:modal-body>
                {{ modalRequest.message }}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn
                        :class="
                            modalRequest.id === 0
                                ? 'primary-button'
                                : 'danger-button'
                        "
                        text
                        @click="clickModalOk(modalRequest.id)"
                    >
                        {{ $t("backoffice.actions.ok") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {ModulesServicesGetModulesList} from "@services/backoffice/Modules/ModulesServices.js";
import {
    NotificationServicesCreateAndUpdateTooltipModule,
    NotificationServicesDeleteTooltipModule,
    NotificationServicesGetTooltipsModules,
} from "@services/backoffice/Notifications/NotificationServices";
import {required} from "@src/utils/validations.js";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {
        BaseModal,
        InputFile: () => import("@components/b2b/widgets/InputFile.vue"),
    },
    data() {
        return {
            modules: [],
            availableModules: [],
            tooltipsList: [],
            colIsReady: false,
            addModeActivated: false,
            formRules: { defaultRules: [required] },
            modalRequest: {
                show: false,
                message: "",
                id: 0,
                title: "",
                iconColor: "",
                iconName: "",
            },
            fileUpload: null,
            clearUpload: false,
            isFileExist: false,
            modalUpload: {
                show: false,
                id_upload: null,
                title: "",
                id: null,
                tooltipData: null,
            },
            modalDuplicate: {
                show: false,
            },
            fileTypesAvatar: ["image/jpg", "image/png", "image/jpeg"],
        };
    },
    methods: {
        getTooltipsList(isDelete) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            this.tooltipsList = _.cloneDeep([]);
            this.colIsReady = false;
            NotificationServicesGetTooltipsModules()
                .then((response) => {
                    let res = response.data.result;
                    if (response.data && response.data.result.length > 0) {
                        res.forEach((item) => {
                            Object.assign(item, { isEditable: false });
                        });
                    }

                    this.tooltipsList = _.cloneDeep(res);

                    this.verifyAvailableModules(res);
                })
                .catch((error) => {
                    throw new Error("NotificationServicesGetTooltipsModules", error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                    setTimeout(() => {
                        this.colIsReady = true;
                    }, 1000);
                });
        },
        verifyAvailableModules(res) {
            let newModulesArray = [];
            if (res) {
                res.forEach((tooltip) => {
                    const filter = this.modules.find(
                        (mdule) => mdule.value == tooltip.moduleId
                    );
                    if (filter) {
                        newModulesArray.push(filter);
                    }
                });
            }
            this.availableModules = this.modules.filter(
                (x) => !newModulesArray.includes(x)
            );
        },
        getModules() {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            ModulesServicesGetModulesList()
                .then((response) => {
                    this.$store.commit(
                        "backofficeModulesDropdown/setModulesDropdowns",
                        response.data.result
                    );
                    this.modules = response.data.result;
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error("error to get dropdowns values", error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        addNewModuleTooltip() {
            if (this.addModeActivated) {
                return;
            }
            const newTooltipModule = {
                moduleId: "",
                image: "",
                isEditable: true,
            };
            if (!this.tooltipsList) this.tooltipsList = [];
            this.tooltipsList.push(newTooltipModule);
            this.addModeActivated = true;
        },
        verifyEditables() {
            return this.tooltipsList.some((e) => e.isEditable === true);
        },
        handleClickClose(tooltipData) {
            this.tooltipsList.splice(-1);
            this.addModeActivated = false;
        },
        handleClickToSave(tooltipData) {
            if (tooltipData.moduleId !== "") {
                const isCreate = true;
                this.createOrUpdateTooltipModule(tooltipData, isCreate);
            } else {
                return;
            }
        },
        createOrUpdateTooltipModule(tooltipData, isCreate, img, imgFile) {
            let body = {
                moduleId: tooltipData.moduleId,
            };
            body = JSON.stringify(body);
            let image = "";
            if (isCreate) {
                image = tooltipData.imageFile;
            } else {
                image = imgFile;
            }
            let requestBody = "";
            if (image != "") {
                image.append("request", body);
                requestBody = image;
            } else {
                let formData = new FormData();
                formData.append("request", body);
                requestBody = formData;
            }
            NotificationServicesCreateAndUpdateTooltipModule(requestBody)
                .then((response) => {
                    let tList = _.cloneDeep(this.tooltipsList);
                    tList.forEach((e) => {
                        Object.assign(e, { isEditable: false });
                        if (tooltipData.moduleId == e.moduleId) {
                            Object.assign(e, {
                                image: response.data.result.image,
                            });
                        }
                    });
                    this.addModeActivated = false;
                    this.tooltipsList = _.cloneDeep(tList);
                })
                .catch((error) => {
                    if (error.response.data.errorMessage) {
                        this.modalRequest.message =
                            error.response.data.errorMessage;
                        this.modalRequest.title = this.$t(
                            "backoffice.general.warning"
                        );
                        this.modalRequest.iconName = "mdi-alert-outline";
                        this.modalRequest.iconColor = "warning";
                        this.modalRequest.show = true;
                        this.modalRequest.id = 1;
                    } else {
                        this.modalRequest.message = this.$t(
                            "backoffice.notifications.messages.error-create"
                        );
                        this.modalRequest.title = this.$t(
                            "backoffice.general.warning"
                        );
                        this.modalRequest.iconName = "mdi-alert-outline";
                        this.modalRequest.iconColor = "warning";
                        this.modalRequest.show = true;
                        this.modalRequest.id = 1;
                    }
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        "NotificationServicesCreateAndUpdateTooltipModule",
                        error
                    );
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                    setTimeout(() => {
                        this.getTooltipsList(isCreate);
                    }, 1000);
                });
        },
        clickModalOk(id) {
            if (id === 1) {
                this.modalRequest.show = false;
                this.modalRequest.id = 1;
            } else {
                this.modalRequest.show = false;
                this.modalRequest.id = 0;
                this.addModeActivated = false;
            }
        },
        validFileAvatarType(file) {
            return this.fileTypesAvatar.includes(file.type);
        },
        previewImage(evt, tooltipData) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            evt.preventDefault();

            if (this.validFileAvatarType(evt.target.files[0])) {
                let selectedFile = evt.target.files[0];
                let url = URL.createObjectURL(selectedFile);

                let formData = new FormData();
                formData.append("image", evt.target.files[0]);

                this.onChangeImage(formData, url, tooltipData);
            }

            this.$store.commit("loadings/setStateLoadingTemplate", false);
        },
        onChangeImage(row, url, tooltipData) {
            if (tooltipData.isEditable == false) {
                this.createOrUpdateTooltipModule(tooltipData, false, url, row);
            } else {
                // this.createOrUpdateTooltipModule(tooltipData, true, url, row);
                const findIndex = this.tooltipsList.findIndex(
                    (e) => e.moduleId == tooltipData.moduleId
                );
                if (findIndex != -1) {
                    let cloneList = _.cloneDeep(this.tooltipsList);
                    cloneList[findIndex].image = url;
                    cloneList[findIndex]["imageFile"] = row;
                    this.tooltipsList = cloneList;
                }
            }
        },
        handleDeleteTooltipModule(tooltipData) {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            NotificationServicesDeleteTooltipModule(tooltipData.moduleId)
                .then((response) => {
                    //
                })
                .catch((error) => {
                    throw new Error(
                        "NotificationServicesDeleteTooltipModule",
                        error
                    );
                })
                .finally(() => {
                    // this.$store.commit('loadings/setStateLoadingTemplate', false);
                    setTimeout(() => {
                        const isDelete = true;
                        this.getTooltipsList(isDelete);
                    }, 1000);
                });
        },
        renderModuleName(moduleId) {
            const filterModule = this.modules.filter(
                (e) => e.value == String(moduleId)
            );
            if (!filterModule || filterModule.length == 0) {
                return "";
            }
            return filterModule[0].name;
        },
    },
    mounted() {
        this.getModules();
        this.getTooltipsList();
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";

/* .row_tooltipdata {
    -webkit-animation: fade 1s linear forwards;
    animation: fade 1s linear forwards;
}

@keyframes fade {
  0%,100% { opacity: 1 }
  50% { opacity: 0 }
}

@-webkit-keyframes fadeinout {
  0%,100% { opacity: 0; }
  50% { opacity: 1; }
}

@keyframes fadeinout {
  0%,100% { opacity: 0; }
  50% { opacity: 1; }
} */
.button-upload {
    color: $grey;
    display: flex;
    align-items: center;
    &:hover {
        color: var(--v-primary-base);
        ::v-deep svg {
            path {
                fill: var(--v-primary-base) !important;
            }
        }
    }
}
.upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
}
.row_tooltipdata:nth-child(even) {
    background: $grey-light;
}
</style>
